/* @sravni/react-header version 0.2.43 */
var defaultUserNavigation = [
    {
        "text": "Баланс",
        "isTextVisible": true,
        "href": "https://sravni.id/user/profile/wallet/",
        "customStyle": "",
        "icon": "https://s91588.cdn.ngenix.net/shared/icons/WalletBag.svg",
        "noindex": false,
        "nofollow": false,
        "isLink": true,
        "openInNew": false,
        "children": []
    },
    {
        "text": "Кредитный рейтинг",
        "isTextVisible": true,
        "href": "https://sravni.market/scoring/",
        "customStyle": "",
        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Scoring.svg",
        "noindex": false,
        "nofollow": false,
        "isLink": true,
        "openInNew": false,
        "children": []
    },
    {
        "text": "Кредиты",
        "isTextVisible": true,
        "href": "https://sravni.id/user/profile/credits/",
        "customStyle": "",
        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Orders.svg",
        "noindex": false,
        "nofollow": false,
        "isLink": true,
        "openInNew": false,
        "children": []
    },
    {
        "text": "Вклады",
        "isTextVisible": true,
        "href": "https://sravni.id/user/profile/savings/",
        "customStyle": "",
        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Deposit.svg",
        "noindex": false,
        "nofollow": false,
        "isLink": true,
        "openInNew": false,
        "children": []
    },
    {
        "text": "Страховые полисы",
        "isTextVisible": true,
        "href": "https://sravni.id/user/profile/insurance-policies/",
        "customStyle": "",
        "icon": "https://s91588.cdn.ngenix.net/shared/icons/ShieldSafety.svg",
        "noindex": false,
        "nofollow": false,
        "isLink": true,
        "openInNew": false,
        "children": []
    },
    {
        "text": "Ответы и комментарии",
        "isTextVisible": true,
        "href": "https://sravni.id/user/profile/activity/",
        "customStyle": "",
        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Review.svg",
        "noindex": false,
        "nofollow": false,
        "isLink": true,
        "openInNew": false,
        "children": []
    },
    {
        "text": "Приведи друга",
        "isTextVisible": true,
        "href": "https://www.sravni.ru/promo/sharefriend/",
        "customStyle": "",
        "icon": "https://s91588.cdn.ngenix.net/shared/icons/Needlework.svg",
        "noindex": false,
        "nofollow": false,
        "isLink": true,
        "openInNew": false,
        "children": []
    },
    {
        "text": "Профиль",
        "isTextVisible": true,
        "href": "https://sravni.id/user/profile/",
        "customStyle": "",
        "icon": "https://s91588.cdn.ngenix.net/shared/icons/User.svg",
        "noindex": false,
        "nofollow": false,
        "isLink": true,
        "openInNew": false,
        "children": []
    }
];

export { defaultUserNavigation };
//# sourceMappingURL=defaultUserNavigation.js.map
